// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge_badge__1gp36","main":"badge_main__VXQHG","badgeImages":"badge_badgeImages__25XK-","paragraph":"badge_paragraph__1UTus"};